/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { GetProjectTimesUpdateQuery } from '../../models/get-project-times-update-query';
import { GetProjectTimesUpdateQueryResult } from '../../models/get-project-times-update-query-result';

export interface ApiProjectTimeUpdateGetAllProjectTimeUpdatesPost$Params {
  
    /**
     * [Id for project]
     */
    body?: GetProjectTimesUpdateQuery
}

export function apiProjectTimeUpdateGetAllProjectTimeUpdatesPost(http: HttpClient, rootUrl: string, params?: ApiProjectTimeUpdateGetAllProjectTimeUpdatesPost$Params, context?: HttpContext): Observable<StrictHttpResponse<GetProjectTimesUpdateQueryResult>> {
  const rb = new RequestBuilder(rootUrl, apiProjectTimeUpdateGetAllProjectTimeUpdatesPost.PATH, 'post');
  if (params) {
    rb.body(params.body, 'application/*+json');
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'text/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<GetProjectTimesUpdateQueryResult>;
    })
  );
}

apiProjectTimeUpdateGetAllProjectTimeUpdatesPost.PATH = '/api/ProjectTimeUpdate/GetAllProjectTimeUpdates';
